import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const allowedRoles = (route.data['roles'] || []).map((r: string) => r.toLowerCase().trim());
    const user = this.auth.getUser();
    const rawRole = user?.role || this.auth.getRole() || '';
    const userRole = rawRole.toLowerCase().trim();

    //console.log('%c[RoleGuard] 👤 User Role:', 'color: #2ecc71', userRole);
    //console.log('%c[RoleGuard] 🎯 Allowed Roles:', 'color: #3498db', allowedRoles);

    if (allowedRoles.length === 0) {
      //console.log('%c[RoleGuard] ✅ No role restriction — access granted.', 'color: #2ecc71');
      return true;
    }

    if (allowedRoles.includes(userRole)) {
      //console.log('%c[RoleGuard] ✅ Access granted for role:', 'color: #2ecc71', userRole);
      return true;
    }

    if (this.auth.isAdmin()) {
      //console.log('%c[RoleGuard] ✅ Admin override.', 'color: #2ecc71');
      return true;
    }

   // console.warn('%c[RoleGuard] ❌ Access denied for role:', 'color: #e74c3c', userRole);
    this.router.navigate(['/unauthorized']);
    return false;
  }
}
